<template>
  <div class="container" :class="{ error }">
    <wrap-container class="grid-container grid-container--6-6">
      <div class="item col1">
        <div class="input-container">
          <input
            type="radio"
            :name="'option-' + $parent._uid"
            :id="'option-particular-' + $parent._uid"
            value="particular"
            @input="$emit('input', $event.target.value)"
            @blur="onBlur('modificar domicilio', 'particular')"
            :checked="!esOtroDomicilio"
          />
          <label :for="'option-particular-' + $parent._uid" data-obfuscate
            >En mi domicilio</label
          >
        </div>
        <div class="descripcion" v-if="value === 'particular'">
          <p data-obfuscate>{{ particular.desDomi }}</p>
          <p data-obfuscate>
            {{ particular.codPost }}
            {{ particular.localid }}
          </p>
          <p data-obfuscate>{{ provinciaFormat.label }}, Argentina</p>
          <custom-link
            label="Modificar"
            :analyticsName="analyticsNameCustomLink"
            @click.native="modificarDomicilio()"
          />
        </div>
      </div>
      <div class="item col2">
        <div class="input-container">
          <input
            type="radio"
            :name="'option-' + $parent._uid"
            :id="'option-otro-' + $parent._uid"
            value="otro"
            @input="$emit('input', $event.target.value)"
            @click="agregarDomicilio"
            @blur="onBlur('otro domicilio', 'otro')"
            :checked="esOtroDomicilio"
          />
          <label :for="'option-otro-' + $parent._uid" data-obfuscate
            >Otro domicilio</label
          >
        </div>
        <div class="descripcion" v-if="value === 'otro'">
          <p data-obfuscate>{{ otro.desDomi }}</p>
          <p data-obfuscate>
            {{ otro.codPost }}
            {{ otro.localid }}
          </p>
          <p data-obfuscate>{{ provinciaFormatOtro.label }}, Argentina</p>
          <custom-link label="Modificar" @click.native="modificarDomicilio()" />
        </div>
      </div>
    </wrap-container>
    <change-address
      :show="showModal"
      @close="cerrarModal($event)"
      @aceptar="aceptar"
      :value="direccion"
      :otroDomicilio="esOtroDomicilio"
    />
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono de error" />
      <p v-safe-html="error"></p>
    </span>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import ChangeAddress from "@/components/core/modals/ChangeAddress";
import CustomLink from "@/components/core/CustomLink";
import { byValue, provincias } from "@/config/constants";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "AddressSelector",
  data() {
    return {
      showModal: false,
      checked: false
    };
  },
  components: { WrapContainer, CustomLink, ChangeAddress },
  props: {
    value: String,
    particular: Object,
    otro: Object,
    analyticsName: {
      type: String,
      default: null
    },
    analyticsNameSalesButtonRecibido: {
      type: String,
      default: null
    },
    analyticsNameCustomLink: {
      type: String,
      default: null
    }
  },
  computed: {
    esOtroDomicilio() {
      return this.value === "otro";
    },
    provinciaFormat() {
      return byValue(this.particular.codProv, provincias);
    },
    provinciaFormatOtro() {
      return byValue(this.otro.codProv, provincias);
    },
    direccion() {
      if (!this.showModal) {
        /**
         * Agregamos una dependencia del estado del modal
         * a la computed para forzar el update al
         * abrir/cerrar el modal
         */
        return {};
      }
      if (this.esOtroDomicilio) {
        return cloneDeep(this.otro);
      }
      return cloneDeep(this.particular);
    },
    error() {
      if (!this.checkValid() && this.checked) {
        /** Indicamos si el domicilio inválido es el principal o el otro */
        let type = this.esOtroDomicilio ? "<strong>principal</strong>" : "";
        return `El domicilio ${type} no es válido`;
      }
      return null;
    }
  },
  methods: {
    agregarDomicilio() {
      this.showModal = true;
      document.getElementsByTagName("body")[0].classList.add("lock-scroll");
    },
    modificarDomicilio() {
      this.showModal = true;
      document.getElementsByTagName("body")[0].classList.add("lock-scroll");
    },
    cerrarModal(valid) {
      this.showModal = false;
      document.getElementsByTagName("body")[0].classList.remove("lock-scroll");
      this.$emit("cerrar-modal", valid);
    },
    aceptar() {
      if (this.esOtroDomicilio && !this.otro.inusual) {
        document
          .getElementsByTagName("body")[0]
          .classList.remove("lock-scroll");
        this.showModal = false;
      } else if (!this.esOtroDomicilio && !this.particular.inusual) {
        this.showModal = false;
        document
          .getElementsByTagName("body")[0]
          .classList.remove("lock-scroll");
      }
    },
    onBlur() {
      this.$emit("onBlur");
    },
    checkValid() {
      /**
       * Validacion para el form-validator para que no permita
       * avanzar con un domicilio inválido
       */
      this.checked = true;

      if (this.esOtroDomicilio) {
        return !this.particular.inusual && !this.otro.inusual;
      }

      return !this.particular.inusual;
    }
  }
};
</script>

<style scoped>
div.container {
  display: block;
  margin-bottom: 0px;
}

div.item {
  vertical-align: top;
  margin-bottom: 24px;
}

label.error {
  color: #b92a45;
}

span.error {
  margin-left: 0;
  margin-bottom: 20px;
  margin-top: 8px;
  display: block;
}

/* Estilos del detalle del domicilio particular */
div.descripcion {
  padding-top: 17px;
  padding-left: 45px;
  display: block;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #121212;
}

div.descripcion p {
  margin: 0;
  margin-bottom: 3px;
}

/* optional styles, I'm using this for centering radiobuttons */
.input-container {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 56px;
}

/* Estilo para errores */
div.container.error {
  background: #fcdfdf;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

/* Estilos del radio */
/* https://stackoverflow.com/questions/26270168/how-to-customize-radio-button-in-html */
input[type="radio"] {
  /* remove standard background appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 24px;
  height: 24px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  border: 1px solid #666666;
  background-color: white;
  border-radius: 50%;
  margin-top: 0px;
  margin-right: 8px;
  margin-left: 13px;
  cursor: pointer;
}

label {
  cursor: pointer;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
}

/* appearance for checked radiobutton */
input[type="radio"]:checked {
  background-color: #004481;
}

input[type="radio"]:focus {
  outline: none;
}

input[type="radio"]:checked + label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
</style>
